import { render, staticRenderFns } from "./LogAccess.vue?vue&type=template&id=5c6d56ea&scoped=true"
import script from "./LogAccess.vue?vue&type=script&lang=js"
export * from "./LogAccess.vue?vue&type=script&lang=js"
import style0 from "./LogAccess.vue?vue&type=style&index=0&id=5c6d56ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d56ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6d56ea')) {
      api.createRecord('5c6d56ea', component.options)
    } else {
      api.reload('5c6d56ea', component.options)
    }
    module.hot.accept("./LogAccess.vue?vue&type=template&id=5c6d56ea&scoped=true", function () {
      api.rerender('5c6d56ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/configuration/LogAccess.vue"
export default component.exports